import React from 'react';
import './ChatbotWidget.css';

const Options = ({ options, handleOptionClick }) => {
  return (
    <div className="chat-options-container">
      {options.map((option, index) => (
        option.link ? (
          <button
            key={index}
            className="chat-option-button"
            href={option.link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.preventDefault();
              window.open(option.link, '_blank');
            }}
          >
            {option.text}
          </button>
        ) : (
          <button
            key={index}
            className="chat-option-button"
            onClick={() => handleOptionClick(option)}
          >
            {option.text}
          </button>
        )
      ))}
    </div>
  );
};

export default Options;